import styled from 'styled-components';

type WrapperProps = {
  error: boolean;
};

const Wrapper = styled.div<WrapperProps>`
  height: 74px;
  position: relative;
  background-color: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.colors.outline};
  transition: all .2s ease-in;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  border: ${(props) => (
    props.error ? `1px solid ${props.theme.colors.red}` : ` 1px solid ${props.theme.colors.widget_background}`
  )};

  &.changed-value {
    background-color: ${(props) => props.theme.colors.main_cta_light};
  }
  
  label {
    position: absolute;
    top: 16px;
    left: 16px;
    color: ${(props) => props.theme.colors.text};
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    pointer-events: none;
  }

  input {
    height: 100%;
    width: 100%;
    padding: 16px;
    margin-top: 7px;
    color: ${(props) => props.theme.colors.text};
    font-size: 13px;
    caret-color: ${(props) => props.theme.colors.main_cta};
    overflow: hidden;

    ::placeholder {
      position: absolute;
      top: ${(props) => (props?.error ? '37px' : '28px')};
      color: ${(props) => props.theme.colors.inactive};
      font-size: 13px;
    }

    :disabled {
      cursor: not-allowed;
      opacity: 50%;
    }
  }

  input[type='file'] {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    height: 60px;
    padding-top: 30px;
  }

  input::file-selector-button {
    background-color: ${(props) => props.theme.colors.widget_background};
    font-weight: bold;
    color: ${(props) => props.theme.colors.text};
    padding: 5px;
    border: thin solid grey;
    border-radius: 6px;
    cursor: pointer;
  }

  &:has(input:focus) {
    border: 1px solid ${(props) => props.theme.colors.main_cta};
    border-radius: 12px;
  }
  
  &:hover {
    border: ${(props) => (`1px solid ${props.theme.colors.white}`)}
  }
`;

const ErrorMessage = styled.p`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  font-family: ManropeLight, sans-serif;
  font-size: 11px;
  color: ${(props) => props.theme.colors.red};
`;

export default { Wrapper, ErrorMessage };
